export default __webpack_public_path__ + "static/media/s4_scape1.b26b5324.png";